Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    sideMenuElevation: 50,
    sideMenuBackgroundColorSurface: tokens.themeSurfaceDefault,
    sideMenuBackgroundColorPrincipal: tokens.themePageDefault,
    sideMenuBackgroundColorHighlight: tokens.themePageHighlight,
    sideMenuBackgroundColorSubdued: tokens.themePageSubdued,
    sideMenuFooterSpacingInset: 24,
    sideMenuMotionExpandDuration: "300ms",
    sideMenuMotionExpandFunction: "ease",
    sideMenuMotionInteractDuration: "100ms",
    sideMenuMotionInteractFunction: "ease",
    sideMenuLinkFontSize: 16,
    sideMenuLinkFontWeight: 400,
    sideMenuLinkLineHeight: "24px",
    sideMenuLinkForegroundColorDefault: tokens.themeInkDefault,
    sideMenuLinkForegroundColorDisabled: tokens.themeInkDisabled,
    sideMenuLinkBackgroundColorDefault: tokens.themeActionNeutralDefault,
    sideMenuLinkBackgroundColorSelected: tokens.themeActionNeutralSelected,
    sideMenuLinkBackgroundColorHover: tokens.themeActionNeutralHover,
    sideMenuLinkBackgroundColorPressed: tokens.themeActionNeutralPressed,
    sideMenuLinkIndicatorColorDefault: "rgba(0, 0, 0, 0)",
    sideMenuLinkIndicatorColorPressed: tokens.themeActionPrimaryPressed,
    sideMenuLinkIndicatorColorSelected: tokens.themeActionPrimaryDefault,
    sideMenuLinkIndicatorWidth: 4,
    sideMenuLinkIndicatorSpacing: 4,
    sideMenuLinkIndicatorBorderRadius: 999,
    sideMenuLinkSpacingHorizontal: 8,
    sideMenuLinkSpacingInsetVertical: 8,
    sideMenuLinkSpacingInsetHorizontal: 24,
    sideMenuBorderWidth: 1,
    sideMenuBorderRadius: 0,
    sideMenuBorderColor: tokens.themeBorderSurface,
    sideMenuSpacerHeight: 32
  }
};